import { authStore, type BootstrapOutcome } from '@jq4race/api-client';

import type { Session } from '../modules/auth/domain/entities/session';

export function getCurrentSession(): Session | null {
  return authStore.get();
}

// pwa-offline-first Slice 3 adversarial-review finding #2 (+ its own
// follow-up review) — the offline-shell gate (_authenticated.tsx) must know
// WHY bootstrapSession() failed to recover a session (unreachable: fetch
// rejected, the boot timeout, or any 5xx/429 — treated as equivalent to no
// connectivity for the operator; vs. unauthenticated: a real 401/403, or
// any other 4xx), not infer it from the devtools-spoofable
// `navigator.onLine`. main.tsx sets this exactly once, right after
// `bootstrapSessionOutcome()` (packages/api-client) settles, BEFORE the
// router mounts — so `_authenticated.tsx`'s beforeLoad always reads a value
// that reflects this page load's actual boot attempt.
//
// Module-level singleton (not the Zustand auth store) because this is
// PWA-local UI-gate state, not shared session data — apps/admin never needs
// it and packages/api-client's auth-store.ts stays untouched, so this
// change carries zero risk to admin's auth flow.
export type AuthBootOutcomeKind = BootstrapOutcome['kind'];

// Defaults to 'unauthenticated' (NOT 'unreachable') — the safe failure
// mode. If something reads this before main.tsx ever calls
// setAuthBootOutcome() (should never happen in practice — main.tsx sets it
// before rendering anything), the offline-shell branch stays LOCKED rather
// than accidentally opening.
let lastAuthBootOutcomeKind: AuthBootOutcomeKind = 'unauthenticated';

export function setAuthBootOutcome(outcome: BootstrapOutcome): void {
  lastAuthBootOutcomeKind = outcome.kind;
}

export function getAuthBootOutcomeKind(): AuthBootOutcomeKind {
  return lastAuthBootOutcomeKind;
}
